import React,{ Suspense, lazy, ReactFragment, ReactPortal, ReactChild, useState } from 'react'
import Loader from '../../Loading'
import { Tabs } from 'antd';
const { TabPane } = Tabs;

const Hotels = lazy(() => import('./Hotels'))

type propTypes = {
    isEditable: () => boolean
    cancelEditable: () => boolean
  }

const NearbyHotels = (props: propTypes) => {

    const [editionMode, setEditionMode] = useState<boolean>(false)
    const [categoryEnabled, setCategoryEnabled] = useState<string | number>()

    const isEditable = (category: string) => {
        setEditionMode(true)
        setCategoryEnabled(category)
    }

    const cancelEditable = () => {
        setCategoryEnabled('0')
        setEditionMode(false)
    }
    
    const Loading: () =>  boolean | ReactChild | ReactFragment | ReactPortal | null = () => {
        return (
        <Loader type="medium" />
        )
    }

    return (<>
        <Tabs defaultActiveKey="1">
        <TabPane
          tab="Nearby Hotels"
          key="1"
          disabled={editionMode && categoryEnabled !== '1'}
        >
          {
              <Suspense fallback={Loading()}>
                  <Hotels/>
              </Suspense>
          }
        </TabPane>
      </Tabs>
    </>)
}

export default NearbyHotels